export default __webpack_public_path__ + "static/screenshot.a1446f78c03870f0cd8289b6f4fa974d.png";